import { render, staticRenderFns } from "./RecordingDetailsTabPublic.vue?vue&type=template&id=3c697174"
import script from "./RecordingDetailsTabPublic.vue?vue&type=script&lang=js"
export * from "./RecordingDetailsTabPublic.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetailsTabPublic.vue?vue&type=style&index=0&id=3c697174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports